import { render, staticRenderFns } from "./DeviceClass.vue?vue&type=template&id=4b7b869d&scoped=true&"
import script from "./DeviceClass.vue?vue&type=script&lang=js&"
export * from "./DeviceClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7b869d",
  null
  
)

export default component.exports